import { Injectable } from '@angular/core';
import { WebSocketService } from './web-socket.service';
import { Subject } from 'rxjs/Rx';

@Injectable({
  providedIn: 'root'
})
export class WebSocketEventRoutingService {

  handlersMap: Map<string, Subject<Object>[]>;

  constructor(private _ws: WebSocketService) {
    this.handlersMap = new Map([]);
    this._ws.eventStream.subscribe(
      data => this.processEvent(data)
    );
  }

  subscribe(eventType: string, observable: Subject<Object>) {
    if (!this.handlersMap.has(eventType)) {
      let observables = [observable];
      this.handlersMap
        .set(eventType, observables);
    } else {
      this.handlersMap
        .get(eventType)
        .push(observable);
    }
  }

  processEvent(event: any) {
    let messageType = event.header.messageType;
    if (this.handlersMap.has(messageType)) {
      this.handlersMap.get(messageType).forEach(subject => {
        subject.next(event);
      })
    }
  }
}
